import { defineMessages } from 'react-intl';

const messages = defineMessages({
  gz: '广州',
  hz: '杭州',
  sh: '上海',
  hk: '香港',
});

export default messages;
